<template lang="pug">
	.payment-form
		.payment-form__header
			a.payment-form__goBack(@click="goBack()") Back
		.g.g--centered(v-if="!paymentDetails || !paymentDetails.isSuccessful")
			template(v-for="item in config.inputs")
				.g__c.g__c--md4(:class="`g__c--md${item.columns}`")
					.payment-form__input(:class="{ 'required' : item.required }")
						span.payment-form__eyebrow
							label {{ item.label }}:
							label.payment-form__message(v-show="!valid[item.field]") {{ item.message }}

						input(
							v-if="item.type === 'text' || item.type === 'number'"
							v-model="selected[item.field]"
							:type="item.type"
							:class="{ 'is-invalid' : !valid[item.field]}"
							:maxlength="item.max"
							@focus="focusEvent(item)"
						)
						select(
							v-if="item.type === 'dropdown'"
							v-model="selected[item.field]"
							:class="{ 'is-invalid' : !valid[item.field]}"
							@focus="focusEvent(item)"
						)
							option(v-for="option in options[item.options]", :value="option.value") {{ option.text }}
		.payment-form__payment-message
			p.error(v-if="invalidMessage.length > 0") {{ invalidMessage }}
			p.error(v-if="paymentDetails && !paymentDetails.isSuccessful") {{ paymentDetails.error }}
			span.success(v-if="paymentDetails && paymentDetails.isSuccessful")
				p.flair Your payment has been successfully completed and processed.
				p.flair Thank you very much for your payment. Please allow 2 – 3 days for payments to post.
				p You will receive an email receipt for this transaction shortly, which will be sent to the email address you entered on the payment page.
				p Have a great day and we appreciate your business!
		.payment-form__footer
			h5 Total Payment Amount: {{ totalDue }}
			button(v-if="!paymentDetails || !paymentDetails.isSuccessful").btn.btn--secondary(@click="payNow")
				label(v-if="!processingPayment") Pay Now
				div.lds-ring(v-else)
					div
					div
					div
					div
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	name: "PaymentForm",
	components: {
	},
	data: function () {
		return {
			invalidMessage: '',
			options: {
				months: [],
				states: [],
				years: [],
			},
			selected: {
				address: '',
				address2: '',
				ccNumber: '',
				ccv: '',
				city: '',
				email: '',
				firstName: '',
				lastName: '',
				mm: '',
				state: '',
				yyyy: '',
				zipCode: '',
			},
			valid: {
				address: true,
				ccNumber: true,
				ccv: true,
				city: true,
				email: true,
				firstName: true,
				lastName: true,
				mm: true,
				state: true,
				yyyy: true,
				zipCode: true,
			},
		};
	},
	computed: {
		...mapGetters(["config", "loading", "invoices", "processingPayment", "paymentDetails"]),
		totalDue() {
			let val = 0;
			this.invoices.forEach((el) => {
				val += el.balance;
			})
			let dollarAmount = val.toFixed(2)

			return `$${dollarAmount}`;
		},
	},
	watch: {
		async paymentDetails() {
			if (this.paymentDetails && this.paymentDetails.isSuccessful) {
				await this.invoices.forEach((invoice) => {
					let obj = {
						paymentReceivedDate: new Date().toISOString(),
						creditCardHolderName: `${this.selected.firstName} ${this.selected.lastName}`,
						creditCardNumber: this.paymentDetails.authorizeNetResponse.transactionResponse.accountNumber,
						creditCardType: this.paymentDetails.authorizeNetResponse.transactionResponse.accountType,
						transactionID: this.paymentDetails.authorizeNetResponse.transactionResponse.transId,
						invoice: invoice.invoiceNumber,
						jobNumber: invoice.orderNumber,
						database: invoice.invoiceFoundAt,
						invoicePaid: invoice.balance,
						email: this.selected.email
					}
					this.savePaymentData({payload: `${this.$root.webq}/api/payment/savepaymentdata`, data: obj });
				})

				this.selected = {
					address: '',
					address2: '',
					ccNumber: '',
					ccv: '',
					city: '',
					email: '',
					firstName: '',
					lastName: '',
					mm: '',
					state: '',
					yyyy: '',
					zipCode: '',
				};
			}
		}
	},
	methods: {
		...mapActions(["payInvoice", "savePaymentData"]),
		focusEvent(el) {
			this.valid[el.field] = true;
			this.invalidMessage = '';
		},
		goBack() {
			if (this.paymentDetails && this.paymentDetails.isSuccessful) {
				this.$emit('reset');
			} else {
				this.$emit('goBack');
			}
		},
		payNow() {
			let valid = this.validate();
			if (valid) {
				let obj = {
					invoices: this.invoices,
					creditCardInfo: this.selected
				}

				this.payInvoice({payload: `${this.$root.api}/Payment/PayInvoice`, data: obj });
			}
		},
		validate() {
			let valid = true;
			this.config.inputs.forEach((el) => {
				if (el.required) {
					if (el.validation === 'email') {
						let emailRegEx = /\S+@\S+\.\S+/;
						let validEmail = emailRegEx.test(this.selected[el.field]);
						if (!validEmail) {
							this.valid[el.field] = false;
							valid = false;
						}
					} else if (this.selected[el.field].length === 0 || (el.min && this.selected[el.field].length < el.min) || (el.max && this.selected[el.field].length > el.max)) {
						this.valid[el.field] = false;
						valid = false;
					}
				}
			})

			if (valid) {
				let currMonth = new Date().getMonth() + 1;
				let currYear = new Date().getFullYear();
				let fieldMM = parseInt(this.selected.mm);
				let fieldYYYY = parseInt(this.selected.yyyy);

				if (fieldYYYY === currYear && fieldMM < currMonth) {
					this.invalidMessage = 'Invalid Expiration Date';
					valid = false;
				}
			}

			return valid;
		},
	},
	mounted() {
		this.options.months = this.config.options.months;
		this.options.states = this.config.options.states;

		let currentYear = new Date().getFullYear();
		this.options.years.push({ text: currentYear, value: currentYear.toString() });
		for (let i = 1; i < 10; i++) {
			this.options.years.push({ text: currentYear + i, value: (currentYear + i).toString() });
		}
	}
};
</script>

<style scoped lang="scss">
.payment-form {
	&__header {
		margin-bottom: 2rem;
	}
	&__goBack {
		cursor: pointer;
		&:before {
			@include icon;
			content: "\e90b";
			font-size: .875rem;
			margin-right: .5rem;
		}
	}
	.g__c {
		margin-top: 1rem !important;
	}
	&__input {
		display: flex;
		flex-direction: column;
		position: relative;
		&.required {
			label:first-of-type:after {
				padding-left: .25rem;
				content: '*';
				color: red;
			}
			select,
			input {
				border: 1px solid black;
			}
			select.is-invalid,
			input.is-invalid {
				border: 1px solid red;
				background: rgba(255, 0, 0, 0.2);
			}
		}
		input {
			padding: .5rem 1rem;
		}
		select {
			padding: .3rem 1rem;
		}
	}
	&__eyebrow {
		display: flex;
		justify-content: space-between;
	}
	&__message {
		line-height: 26px;
		font-size: .85rem;
		color: red;
	}
	&__payment-message {
		line-height: 26px;
		font-size: 1rem;
		text-align: center;
		margin-bottom: 0;
		.error {
			color: red;
		}
		.success {
			p {
				margin: 0;
			}
			p:first-of-type {
				border-bottom: 1px solid $lightGray;
			}
			p.flair {
				font-weight: bold;
				color: $orange;
				line-height: 2.5rem;
			}
		}
	}
	&__footer {
		padding-top: 2rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		h5 {
			margin: auto 0;
		}
	}

	.lds-ring {
		display: inline-block;
		position: relative;
		width: 74px;
		height: 1rem;
		padding: 0 26px;
		div {
			box-sizing: border-box;
			display: block;
			position: absolute;
			width: 1rem;
			height: 1rem;
			border: 2px solid $white;
			border-radius: 50%;
			animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
			border-color: $white transparent transparent transparent;
			&:nth-child(1) {
				animation-delay: -0.45s;
			}
			&:nth-child(2) {
				animation-delay: -0.3s;
			}
			&:nth-child(3) {
				animation-delay: -0.15s;
			}
		}
	}
	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

}
</style>
